
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import AddressDialog from "@/components/Customers/AddressDialog.vue";
import RideTimeRangeInput from "@/components/Shared/RideTimeRangeInput.vue";

import { getGoogleMapsAPI } from "gmap-vue";

import TravelMode from "@/models/GoogleMaps/TravelMode";

import {
  AddressModel,
  AddressType,
  CustomerApi,
  EnumsApi,
  GetCustomersModel,
  GetOrderResponse,
  SlotInstanceModel,
  HandicapEquipment,
  OrderApi,
  OrderDayModel,
  SaveOrderRequest,
  SlotinstanceApi,
  EscortInfoModel,
} from "@/api";
import { AxiosError } from "axios";

import {
  getDefaultApiConfig,
  parseAxiosError,
  buildEscortOptions,
  ValidationRules,
} from "@/utils";
import {
  Escort,
  OrderRepetitionFrequency,
  OrderSaveMode,
  OrderState,
  OrderType,
  TimeType,
} from "@/models/Orders/OrderEnums";
import { debounce } from "vue-debounce";
import AcceptanceTypeToggle from "@/components/Orders/AcceptanceTypeToggle.vue";
import OrderTypeToggle from "@/components/Orders/OrderTypeToggle.vue";
import QuantitySelector from "@/components/Orders/QuantitySelector.vue";
import EscortOptions from "@/components/Shared/EscortOptions.vue";
import RichTextInput from "@/components/Shared/RichTextInput.vue";

@Component({
  name: "OrderDetail",
  components: {
    AddressDialog,
    RideTimeRangeInput,
    AcceptanceTypeToggle,
    OrderTypeToggle,
    QuantitySelector,
    EscortOptions,
    RichTextInput,
  },
})
export default class OrderDetail extends Vue {
  @Prop({ default: false })
  darkMode!: boolean;

  @Prop({ default: false })
  dialog: boolean;

  @Prop({ default: undefined })
  passedOrder: GetOrderResponse;

  @Prop({ default: 0 })
  update: number;

  @Prop({ default: undefined })
  customerId: number | undefined;

  @Prop({ default: false })
  canOpenRidesMap!: boolean;

  @Prop({ default: false })
  ridesMapLoading!: boolean;

  id = 0;

  isRepeated = false;

  loading = false;
  loadingCustomers = false;
  loadingSlots = false;
  loadingCancel = false;
  loadingDelete = false;
  loadingUpdate = false;
  loadingConfirm = false;

  isAddressDialogOpen = false;
  isFromAddress = false;
  addressDialogOpen = 0;

  isCancelDialogOpen = false;
  isUpdateSinceDialogOpen = false;
  showValidationSummary = false;

  pickerDate: string | null = null;
  activePicker = "DATE";
  isInstantiablePropertyChanged = false;
  isConfirmationDialogOpen = false;
  confirmNote = "";

  errors: string[] = [];

  orderApi = new OrderApi(getDefaultApiConfig());
  customerApi = new CustomerApi(getDefaultApiConfig());
  slotInstanceApi = new SlotinstanceApi(getDefaultApiConfig());
  enumsApi = new EnumsApi(getDefaultApiConfig());

  orderTypes = OrderType;
  orderStates = OrderState;
  validationRules = ValidationRules;

  selectedAddress: AddressModel | null = {
    city: "",
    postCode: "",
    street: "",
    streetNumber: "",
    name: "",
  };

  order: SaveOrderRequest | any = {
    id: 0,
    acceptanceType: undefined,
    customerId: 0,

    escortDog: false,
    escortLuggage: false,
    addressFrom: {
      id: 0,

      city: "",
      street: "",
      streetNumber: "",
      postCode: "",

      addressType: 2,
    },
    addressTo: {
      id: 0,

      city: "",
      street: "",
      streetNumber: "",
      postCode: "",

      addressType: 2,
    },
    orderType: OrderType.OneTime,
    repetitionFrequency: OrderRepetitionFrequency.All,
    state: 1,
    slotInstanceId: undefined,
    slotInstanceReturnId: undefined,
    date: undefined,
    dateTo: undefined,
    noteInternal: "",
    noteDriver: "",

    times: [
      {
        isReturn: false,
        weekday: 0,
        pickup: undefined,
        dropoff: undefined,
        primaryTime: 1,
      },
      {
        isReturn: true,
        weekday: 0,
        pickup: undefined,
        dropoff: undefined,
        primaryTime: 1,
      },
    ],
    escorts: [],
    createdByCustomer: false,
    createdOn: undefined,
    createdByInitials: "",
    updateSince: "",
  };

  cancelDate = "";

  customers: GetCustomersModel[] = [];
  toSlotInstances: SlotInstanceModel[] = [];
  returnSlotInstances: SlotInstanceModel[] = [];
  handicapEquipment: HandicapEquipment[] = [];
  originalOrderState = OrderState.New;

  repetitionFrequencies = [
    { text: "Každý týden", value: OrderRepetitionFrequency.All },
    { text: "Sudé týdny", value: OrderRepetitionFrequency.EvenWeeks },
    { text: "Liché týdny", value: OrderRepetitionFrequency.OddWeeks },
  ];

  debouncedLoadCustomers = debounce(this.loadCustomers, 300);

  // eslint-disable-next-line no-undef
  directionService: google.maps.DirectionsService | null = null;

  @Watch("update", { immediate: true, deep: true })
  async onValueChanged() {
    if (this.order && this.order.id && this.order.id > 0) {
      await this.loadOrder();
    }

    if (this.dialog) {
      this.order = {
        id: 0,
        acceptanceType: 1,
        customerId: 0,

        escortDog: false,
        escortLuggage: false,
        addressFrom: {
          id: 0,

          city: "",
          street: "",
          streetNumber: "",
          postCode: "",

          addressType: 2,
        },
        addressTo: {
          id: 0,

          city: "",
          street: "",
          streetNumber: "",
          postCode: "",

          addressType: 2,
        },
        orderType: OrderType.OneTime,
        repetitionFrequency: OrderRepetitionFrequency.All,
        state: 1,
        slotInstanceId: undefined,
        slotInstanceReturnId: undefined,
        date: undefined,
        dateTo: undefined,
        noteInternal: "",
        noteDriver: "",

        times: [
          {
            isReturn: false,
            weekday: 0,
            pickup: undefined,
            dropoff: undefined,
            primaryTime: 1,
          },
          {
            isReturn: true,
            weekday: 0,
            pickup: undefined,
            dropoff: undefined,
            primaryTime: 1,
          },
        ],
        updateSince: "",
      };
    }
  }

  get areAddressesFilledIn() {
    return (
      this.filters.toAddressText(this.order.addressFrom) != "" &&
      this.filters.toAddressText(this.order.addressTo) != ""
    );
  }

  get escortOptions() {
    return buildEscortOptions(this.handicapEquipment, this.order.escorts);
  }

  get google() {
    return getGoogleMapsAPI();
  }

  get isReturn() {
    if (!this.order.times) {
      return false;
    }

    return (
      this.order.times?.some((x) => x.isReturn && x.dropoff && x.pickup) == true
    );
  }

  get saveModes() {
    var modes = [];

    if (this.order.state == OrderState.New) {
      modes.push({ text: "Rozpracovaná", value: OrderSaveMode.Draft });

      if (!this.dialog) {
        modes.push({
          text: "Rozpracovaná a duplikovat",
          value: OrderSaveMode.DraftAndDuplicate,
        });
      }

      modes.push({ text: "Umožnit plánování", value: OrderSaveMode.Plan });

      if (!this.dialog) {
        modes.push({
          text: "Umožnit plánování a duplikovat",
          value: OrderSaveMode.PlanAndDuplicate,
        });
      }

      return modes;
    }

    if (this.order.state != OrderState.Cancelled)
      modes.push(
        { text: "Uložit", value: OrderSaveMode.Plan },
        {
          text: "Uložit a duplikovat",
          value: OrderSaveMode.PlanAndDuplicate,
        }
      );

    return modes;
  }

  get startAndEndDate() {
    var startDate = new Date(this.order.date);
    var endDate = new Date(this.order.date);

    if (this.order.date == "") {
      startDate = new Date();
      endDate = new Date();
    }

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    return { startDate, endDate };
  }

  get returnTime() {
    if (this.order.orderType == OrderType.Repeated || !this.order.times) {
      return {
        pickup: "",
        dropoff: "",
        isReturn: true,
        primaryTime: TimeType.Dropoff,
        weekday: 0,
      };
    }

    var toTime = this.order.times.find((x) => x.isReturn == true);

    if (!toTime) {
      return {
        pickup: "",
        dropoff: "",
        isReturn: true,
        primaryTime: TimeType.Dropoff,
        weekday: 0,
      };
    }

    return toTime;
  }

  set returnTime(value: OrderDayModel) {
    if (this.order.orderType == OrderType.Repeated || !this.order.times) {
      return;
    }

    var idx = this.order.times.findIndex((x) => x.isReturn == true);

    if (idx === -1) {
      if (value != null && value.dropoff && value.pickup) {
        this.order.times.push(value);
        return;
      }

      return;
    }

    this.order.times.splice(idx, 1, value);
  }

  get toTime() {
    if (this.order.orderType == OrderType.Repeated || !this.order.times) {
      return {
        pickup: "",
        dropoff: "",
        isReturn: false,
        primaryTime: TimeType.Dropoff,
        weekday: 0,
      };
    }

    var toTime = this.order.times.find((x) => x.isReturn == false);

    if (!toTime) {
      return {
        pickup: "",
        dropoff: "",
        isReturn: false,
        primaryTime: TimeType.Dropoff,
        weekday: 0,
      };
    }

    return toTime;
  }

  set toTime(value: OrderDayModel) {
    if (this.order.orderType == OrderType.Repeated || !this.order.times) {
      return;
    }

    var idx = this.order.times.findIndex((x) => x.isReturn == false);

    if (idx === -1) {
      if (value != null && value.dropoff && value.pickup) {
        this.order.times.push(value);
        return;
      }

      return;
    }

    this.order.times.splice(idx, 1, value);
  }

  get canCancel() {
    return (
      this.order.state == OrderState.Planned ||
      this.order.state == OrderState.PartialyPlanned
    );
  }

  get canConfirm() {
    return this.order.createdByCustomer;
  }

  get hasCreatedMetadata() {
    return !!(
      this.order &&
      this.order.id &&
      (this.order.createdByInitials || this.order.createdOn)
    );
  }

  get canDelete() {
    return (
      this.order.state == OrderState.New ||
      this.order.state == OrderState.Unplanned ||
      this.order.state == OrderState.Cancelled
    );
  }

  get canSave() {
    return (
      this.order.state == OrderState.New ||
      this.order.state == OrderState.Unplanned ||
      this.order.state == OrderState.PartialyPlanned ||
      this.order.state == OrderState.Planned
    );
  }

  get visibleErrors() {
    const backendErrors = this.errors.filter(
      (error): error is string =>
        typeof error === "string" && error.trim().length > 0
    );

    if (!this.showValidationSummary) {
      return backendErrors;
    }

    return [...this.validationSummaryErrors, ...backendErrors];
  }

  get validationSummaryErrors() {
    const errors: string[] = [];

    if (!this.order.acceptanceType) {
      errors.push("Vyberte způsob přijetí.");
    }

    if (!this.order.customerId) {
      errors.push("Vyberte zákazníka.");
    }

    if (!this.order.date) {
      errors.push("Vyplňte datum objednávky.");
    }

    if (this.order.orderType == OrderType.Repeated) {
      if (!this.order.dateTo) {
        errors.push("Vyplňte datum do.");
      } else if (this.order.dateTo < this.order.date) {
        errors.push("Datum do nesmí být dříve než datum od.");
      }
    }

    return errors;
  }

  get acceptanceTypeRules() {
    return [this.validationRules.Required("Vyberte způsob přijetí.")];
  }

  get customerRules() {
    return [this.validationRules.Required("Vyberte zákazníka.")];
  }

  get dateRules() {
    return [this.validationRules.Required("Vyplňte datum objednávky.")];
  }

  get dateToRules() {
    return [
      this.validationRules.Required("Vyplňte datum do."),
      this.validationRules.DateNotBefore(
        () => this.order.date,
        "Datum do nesmí být dříve než datum od."
      ),
    ];
  }

  mounted() {
    console.log("Test - order detail mounted");
    if (!this.dialog) {
      this.id = Number(this.$route.params.id);
    }

    //var minDate = this.filters.toIsoDate(new Date());
    //this.order.date = minDate;
    //this.order.dateTo = minDate;

    if (this.passedOrder) {
      // this.order = this.passedOrder;
    }

    this.initPage();
  }

  initPage() {
    if (this.id > 0) {
      this.loadOrder();
    }

    if (this.id == 0 && this.customerId) {
      this.order.customerId = Number(this.customerId);

      this.order.acceptanceType = 0;

      this.loadCustomer(this.order.customerId);
    }

    this.loadHandicapEquipment();
  }

  onInstantiablePropertyChanged() {
    if (this.order.state != OrderState.New) {
      this.isInstantiablePropertyChanged = true;
    }
  }

  removeEscortOption(opt: {
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  }) {
    if (!this.order.escorts) return;

    const index = this.order.escorts.findIndex(
      (escortInfo: EscortInfoModel) =>
        escortInfo.escort === opt.escort &&
        escortInfo.escortHandicapEquipmentId === opt.handicapEquipment?.id
    );

    if (index !== -1) {
      this.order.escorts.splice(index, 1);
      this.onInstantiablePropertyChanged();
    }
  }

  setEscortOption(opt: {
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  }) {
    const isNullOption = !opt.escort && !opt.handicapEquipment;

    if (isNullOption) {
      this.order.escorts = this.order.escorts.filter(
        (x: EscortInfoModel) =>
          x.escort == null && x.escortHandicapEquipmentId == null
      );
      this.onInstantiablePropertyChanged();
      return;
    }

    const newEscortInfo: EscortInfoModel = {
      escort: opt.escort ?? undefined,
      escortHandicapEquipmentId: opt.handicapEquipment?.id ?? undefined,
    };

    // Initialize array if not present
    if (!this.order.escorts) {
      this.order.escorts = [];
    }

    this.order.escorts.push(newEscortInfo);

    this.onInstantiablePropertyChanged();
  }

  getSelectedEscortOption() {
    // Check if this.order.escorts is undefined or empty
    if (!this.order.escorts || this.order.escorts.length === 0) {
      return [
        {
          key: "",
          escort: null,
          handicapEquipment: null,
        },
      ];
    }
    // Otherwise, map over this.order.escorts
    return this.order.escorts.map((escort: EscortInfoModel, index: number) => {
      // Find the corresponding handicap equipment using the escortHandicapEquipmentId
      const equip = this.handicapEquipment.find(
        (equipment) => equipment.id === escort.escortHandicapEquipmentId
      );

      return {
        key: `${index}-${escort.escort}-${escort.escortHandicapEquipmentId}`,
        escort: escort.escort || null, // The escort ID or value
        handicapEquipment: equip || null, // The associated handicap equipment
      };
    });
  }

  getWeekDayTime(weekday: number, isReturn: boolean): OrderDayModel {
    var time = this.order.times?.find(
      (x) => x.isReturn == isReturn && x.weekday == weekday
    );

    if (!time) {
      return {
        dropoff: undefined,
        isReturn: isReturn,
        pickup: undefined,
        primaryTime: TimeType.Dropoff,
        weekday: weekday,
      };
    }

    return time;
  }

  setWeekDayTime(weekday: number, isReturn: boolean, time: OrderDayModel) {
    var timeIdx = this.order.times?.findIndex(
      (x) => x.isReturn == isReturn && x.weekday == weekday
    );

    if (!timeIdx || timeIdx == -1) {
      return;
    }

    this.order.times?.splice(timeIdx, 1, time);
  }

  orderTypeChanged() {
    this.order.times = [];
    this.showValidationSummary = false;

    if (this.$refs.form) {
      (this.$refs.form as any).resetValidation();
    }

    if (this.order.orderType == OrderType.Repeated) {
      for (let weekday = 0; weekday < 7; weekday++) {
        this.order.times.push(
          {
            dropoff: undefined,
            isReturn: false,
            pickup: undefined,
            primaryTime: TimeType.Pickup,
            weekday: weekday,
          },
          {
            dropoff: undefined,
            isReturn: true,
            pickup: undefined,
            primaryTime: TimeType.Pickup,
            weekday: weekday,
          }
        );
      }

      this.order.date = undefined;
      this.order.dateTo = undefined;

      return;
    }

    this.order.times = [
      {
        dropoff: undefined,
        isReturn: false,
        pickup: undefined,
        primaryTime: TimeType.Pickup,
        weekday: 0,
      },
      {
        dropoff: undefined,
        isReturn: true,
        pickup: undefined,
        primaryTime: TimeType.Pickup,
        weekday: 0,
      },
    ];

    //this.onDateChanged(this.filters.toIsoDate(new Date()));
  }

  weekDayToWeekDayAbbr(weekday: number) {
    var baseDate = new Date(Date.UTC(2017, 0, 2));

    baseDate.setDate(baseDate.getDate() + weekday);

    return baseDate
      .toLocaleDateString(undefined, { weekday: "short" })
      .toUpperCase();
  }

  private getMondayBasedWeekday(dateStr: string): number {
    // dateStr = "YYYY-MM-DD"
    const d = new Date(`${dateStr}T00:00:00`);
    // JS: 0=Sun ... 6=Sat
    return (d.getDay() + 6) % 7; // 0=Mon ... 6=Sun
  }

  normalizeOneTimeOrderTimes(date: string) {
    const weekday = this.getMondayBasedWeekday(date);

    if (!Array.isArray(this.order.times) || this.order.times.length === 0) {
      this.order.times = [
        {
          isReturn: false,
          weekday,
          pickup: undefined,
          dropoff: undefined,
          primaryTime: TimeType.Pickup,
        },
        {
          isReturn: true,
          weekday,
          pickup: undefined,
          dropoff: undefined,
          primaryTime: TimeType.Pickup,
        },
      ];

      return;
    }

    this.order.times = this.order.times.map((t: any) => ({
      isReturn: !!t.isReturn,
      weekday,
      pickup: t.pickup ?? undefined,
      dropoff: t.dropoff ?? undefined,
      primaryTime: t.primaryTime ?? TimeType.Pickup,
    }));

    const hasOutbound = this.order.times.some((x: any) => x.isReturn === false);
    const hasReturn = this.order.times.some((x: any) => x.isReturn === true);

    if (!hasOutbound) {
      this.order.times.push({
        isReturn: false,
        weekday,
        pickup: undefined,
        dropoff: undefined,
        primaryTime: TimeType.Pickup,
      });
    }

    if (!hasReturn) {
      this.order.times.push({
        isReturn: true,
        weekday,
        pickup: undefined,
        dropoff: undefined,
        primaryTime: TimeType.Pickup,
      });
    }
  }

  onDateChanged(date: string) {
    if (this.order.orderType == OrderType.OneTime) {
      this.order.date = date;
      this.order.dateTo = date;
      this.syncDatePickerMonth(date);

      this.normalizeOneTimeOrderTimes(date);
      this.loadSlotInstances(true);
      this.loadSlotInstances(false);
    }
  }

  onTodayClicked() {
    const today = this.getTodayLocalIsoDate();
    this.activePicker = "DATE";
    this.pickerDate = today.substring(0, 7);
    this.onDateChanged(today);
  }

  getTodayLocalIsoDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  syncDatePickerMonth(date?: string | null) {
    const month = date?.match(/^\d{4}-\d{2}/)?.[0];

    if (month) {
      this.pickerDate = month;
    }
  }

  toMondayBasedWeekday(dateValue: string) {
    const date = new Date(`${dateValue}T00:00:00`);
    return (date.getDay() + 6) % 7;
  }

  resetClonedAddressId(address?: AddressModel | null) {
    if (!address) {
      return;
    }

    if (
      address.addressType === AddressType.Customer ||
      address.addressType === AddressType.Carrier
    ) {
      return;
    }

    address.id = 0;
  }

  onDatePickerWheel(e: WheelEvent) {
    if (this.order.state != this.orderStates.New) return;
    const target = e.target as HTMLElement;
    if (target.closest(".v-date-picker-years")) return;
    e.preventDefault();
    if (!this.pickerDate) return;
    const [year, month] = this.pickerDate.split("-").map(Number);
    const d = new Date(year, month - 1 + (e.deltaY > 0 ? 1 : -1), 1);
    this.pickerDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  }

  onCancelDateChanged(date: string) {
    this.cancelDate = date;
  }

  onUpdateSinceChanged(date: string) {
    this.order.updateSince = date;
  }

  openAddressDialog(address: AddressModel, isFromAddress: boolean) {
    this.isAddressDialogOpen = true;

    this.selectedAddress = JSON.parse(JSON.stringify(address));
    this.isFromAddress = isFromAddress;

    this.addressDialogOpen += 1;
  }

  async saveAddress(address: AddressModel) {
    this.isAddressDialogOpen = false;

    if (address && address.customer?.customerId) {
      var result = await this.customerApi.getCustomer(
        address.customer?.customerId
      );

      if (result.data) {
        if (result.data.addresses.some((x) => x.id == address.id)) {
          let index = result.data.addresses.findIndex(
            (x) => x.id == address.id
          );

          result.data.addresses.splice(index, 1, address);

          try {
            await this.customerApi.saveCustomer(result.data);
          } catch (e) {
            console.error(e);

            this.$sideAlert(
              "V kartě zákazníka je chyba, zkontrolujte údaje",
              "warning"
            );
          }
        }
      }
    }

    if (this.isFromAddress) {
      this.order.addressFrom = this.selectedAddress;
    } else {
      this.order.addressTo = this.selectedAddress;
    }

    if (
      (this.order.addressFrom.googlePlaceId &&
        this.order.addressTo.googlePlaceId) ||
      (this.order.addressFrom.lat &&
        this.order.addressFrom.lng &&
        this.order.addressTo.lat &&
        this.order.addressTo.lng)
    ) {
      this.getDirections();
    }

    this.selectedAddress = null;
  }

  swapAddresses() {
    var addressFrom = JSON.parse(JSON.stringify(this.order.addressFrom));

    this.order.addressFrom = this.order.addressTo;
    this.order.addressTo = addressFrom;

    if (
      (this.order.addressFrom.googlePlaceId &&
        this.order.addressTo.googlePlaceId) ||
      (this.order.addressFrom.lat &&
        this.order.addressFrom.lng &&
        this.order.addressTo.lat &&
        this.order.addressTo.lng)
    ) {
      this.getDirections();
    }
  }

  getOrderAddMissingTimes() {
    if (!this.order.times) {
      return;
    }

    if (
      this.order.orderType == OrderType.OneTime &&
      this.order.times.length <= 1
    ) {
      const weekday = this.order.date
        ? this.getMondayBasedWeekday(this.order.date)
        : 0;

      this.order.times?.push({
        dropoff: undefined,
        isReturn: true,
        pickup: undefined,
        primaryTime: TimeType.Dropoff,
        weekday,
      });

      if (this.order.date) {
        this.normalizeOneTimeOrderTimes(this.order.date);
      }

      return;
    }

    if (this.order.orderType == OrderType.OneTime && this.order.date) {
      this.normalizeOneTimeOrderTimes(this.order.date);
      return;
    }

    for (let weekday = 0; weekday < 7; weekday++) {
      var currentTime = this.order.times.filter((x) => x.weekday == weekday);

      if (currentTime.findIndex((x) => x.isReturn == true) === -1) {
        this.order.times.push({
          dropoff: undefined,
          isReturn: true,
          pickup: undefined,
          primaryTime: TimeType.Pickup,
          weekday: weekday,
        });
      }

      if (currentTime.findIndex((x) => x.isReturn == false) === -1) {
        this.order.times.push({
          dropoff: undefined,
          isReturn: false,
          pickup: undefined,
          primaryTime: TimeType.Pickup,
          weekday: weekday,
        });
      }
    }
  }

  closeOrderCreationDialog() {
    if (this.dialog) {
      this.id = 0;

      this.$emit("close");
    }
  }

  toggleEscortDog() {
    this.order.escortDog = !this.order.escortDog;

    this.onInstantiablePropertyChanged();
  }

  toggleEscortLuggage() {
    this.order.escortLuggage = !this.order.escortLuggage;

    this.onInstantiablePropertyChanged();
  }

  async getDirections() {
    console.log("getting dirs");
    if (!this.google) {
      console.warn("Google is null");
      return;
    }

    if (!this.directionService) {
      this.directionService = new this.google.maps.DirectionsService();
    }

    var result;

    try {
      result = await this.directionService?.route({
        origin: {
          placeId: this.order.addressFrom.googlePlaceId || undefined,
        },
        destination: {
          placeId: this.order.addressTo.googlePlaceId || undefined,
        },
        travelMode: TravelMode.DRIVING,
      });
    } catch (e0) {
      console.error(
        "Failed to get directions using GooglePlaceId, trying coordinates",
        e0
      );

      if (this.order.addressFrom.lat && this.order.addressTo.lat) {
        try {
          result = await this.directionService?.route({
            origin: {
              lat: Number(this.order.addressFrom.lat),
              lng: Number(this.order.addressFrom.lng),
            },
            destination: {
              lat: Number(this.order.addressTo.lat),
              lng: Number(this.order.addressTo.lng),
            },
            travelMode: TravelMode.DRIVING,
          });
        } catch (e1) {
          console.error("Failed to load directions", e1);
          this.$sideAlert("Nepodařilo se načíst trvání", "error");
        }
      }
    }

    if (!result) {
      console.warn("no dirs result");
      return;
    }

    var duration = result.routes[0].legs[0].duration?.value || null;
    this.order.duration = duration || 0;
  }

  async loadOrder() {
    if (this.id <= 0) {
      return;
    }

    this.loading = true;

    if (this.passedOrder) {
      this.order = this.passedOrder;

      if (
        this.passedOrder.customer &&
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.customers.findIndex((x) => x.id == result.data.customer!.id) === -1
      ) {
        this.customers.push(this.passedOrder.customer);
      }
    }

    if (!this.passedOrder) {
      var result = await this.orderApi.getOrder(this.id);

      this.order = result.data;

      this.order.updateSince = this.filters.toIsoDate(new Date());

      if (this.order.duration == 0) await this.getDirections();

      if (
        result.data.customer &&
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.customers.findIndex((x) => x.id == result.data.customer!.id) === -1
      ) {
        this.customers.push(result.data.customer);
      }
    }

    this.getOrderAddMissingTimes();
    this.syncDatePickerMonth(this.order.date);

    this.originalOrderState = this.order.state || OrderState.New;

    this.loading = false;
    this.id;
  }

  async saveOrUpdateOrder(mode: OrderSaveMode) {
    if (this.order.state == OrderState.New) {
      await this.saveOrder(mode);
      return;
    }

    if (this.order.orderType == OrderType.OneTime) {
      await this.saveOrder(mode);
      return;
    }

    if (this.isInstantiablePropertyChanged) {
      this.isUpdateSinceDialogOpen = true;
      return;
    } else if (this.id > 0) {
      await this.orderApi.patchOrderNoninstantiables({
        orderId: this.id,
        acceptanceType: this.order.acceptanceType,
        noteDriver: this.order.noteDriver,
        noteInternal: this.order.noteInternal,
      });
      this.$sideAlert("Uloženo", "accent darken-1");

      this.$emit("saved");

      return;
    }

    await this.saveOrder(mode);
  }

  async saveOrder(mode: OrderSaveMode) {
    this.errors = [];
    this.showValidationSummary = true;

    if (!this.$refs.form || !(this.$refs.form as any).validate()) {
      return;
    }

    this.showValidationSummary = false;

    if (this.order.orderType == OrderType.OneTime && this.order.date) {
      this.order.dateTo = this.order.date;
      this.normalizeOneTimeOrderTimes(this.order.date);
    }

    this.loading = true;

    if (mode >= OrderSaveMode.Plan && this.order.state == OrderState.New) {
      this.order.state = OrderState.Unplanned;
      this.order.updateSince = undefined;
    } else if (this.order.state == OrderState.New) {
      this.order.state = OrderState.New;
      this.order.updateSince = undefined;
    }

    this.order.times = this.order.times?.filter(
      (x) => x.pickup != null && x.dropoff != null
    );

    try {
      var result = await this.orderApi.saveOrder(this.order);

      if (
        result.data.id &&
        mode != OrderSaveMode.DraftAndDuplicate &&
        mode != OrderSaveMode.PlanAndDuplicate
      ) {
        this.$emit("saved", result.data.id);

        if (this.dialog) {
          this.id = 0;

          this.$emit("close");
        }
      } else {
        this.order.id = 0;
        this.id = 0;
        this.order.state = OrderState.New;
        this.resetClonedAddressId(this.order.addressFrom);
        this.resetClonedAddressId(this.order.addressTo);

        this.$emit("saved-duplicate", this.order);

        this.$router.push({
          name: "order",
          params: { id: "0" },
        });
      }

      this.isUpdateSinceDialogOpen = false;

      this.loadOrder();

      this.isInstantiablePropertyChanged = false;

      this.$sideAlert("Uloženo", "accent darken-1");
    } catch (e) {
      const parsedErrors = parseAxiosError(e as AxiosError).filter(
        (error) => error && error.trim().length > 0
      );
      this.errors =
        parsedErrors.length > 0
          ? parsedErrors
          : ["Objednávku se nepodařilo uložit."];
      this.order.state = this.originalOrderState;
    }

    this.loading = false;
  }

  async deleteOrder() {
    if (!this.order || this.order.id == undefined) {
      return;
    }

    this.loadingDelete = true;

    var isConfirmed = await this.$confirm(
      "Jste si jistý?",
      `Opravdu chcete odstranit objednávku?`
    );

    if (!isConfirmed) {
      this.loadingDelete = false;
      return;
    }

    if (this.order.orderType == OrderType.OneTime) {
      await this.orderApi.cancelOrder({ id: this.order.id });
      this.loadingCancel = false;
    }

    if (this.order.orderType == OrderType.Repeated) {
      await this.orderApi.cancelOrder({
        id: this.order.id,
        cancelSince: this.order.date,
      });

      this.loadingDelete = false;
    }

    this.$router.push({ name: "orders" });
    this.isCancelDialogOpen = false;
    this.$sideAlert("Objednávka byla odstraněna", "accent darken-1");
    return;
  }

  async confirmOrder(note: string) {
    if (!this.order || this.order.id == undefined) {
      return;
    }

    this.loadingConfirm = true;

    var isConfirmed = await this.$confirm(
      "Jste si jistý?",
      `Opravdu chcete potvrdit objednávku?`
    );

    if (!isConfirmed) {
      this.loadingConfirm = false;
      return;
    }

    await this.orderApi.confirmOrder(this.order.id, {
      note: note,
    });

    this.loadingConfirm = false;
    this.isConfirmationDialogOpen = false;

    this.$sideAlert("Objednávka byla potvrzena", "accent darken-1");

    await this.loadOrder();
  }

  async cancelOrder(dateSince?: string | undefined) {
    if (!this.order || this.order.id == undefined) {
      return;
    }

    if (this.order.state == OrderState.New) {
      var isConfirmed = await this.$confirm(
        "Jste si jistý?",
        `Opravdu chcete odstranit rozpracovanou objednávku?`
      );

      if (!isConfirmed) {
        return;
      }

      this.loadingCancel = true;

      if (this.order.orderType == OrderType.OneTime) {
        await this.orderApi.cancelOrder({ id: this.order.id });

        this.loadingCancel = false;
      }

      if (this.order.orderType == OrderType.Repeated) {
        await this.orderApi.cancelOrder({
          id: this.order.id,
          cancelSince: this.order.date,
        });

        this.loadingCancel = false;
      }

      this.$router.push({ name: "orders" });
      this.isCancelDialogOpen = false;
      this.$sideAlert("Objednávka byla odstraněna", "accent darken-1");
      return;
    }

    if (this.order.orderType == OrderType.OneTime) {
      isConfirmed = await this.$confirm(
        "Jste si jistý?",
        `Opravdu chcete zrušit objednávku?`
      );

      if (!isConfirmed) {
        return;
      }

      this.loadingCancel = true;

      await this.orderApi.cancelOrder({ id: this.order.id });

      this.loadingCancel = false;
      this.isCancelDialogOpen = false;

      this.$sideAlert("Objednávka byla zrušena", "accent darken-1");

      this.$emit("cancelled");

      await this.loadOrder();
    }

    if (this.order.orderType == OrderType.Repeated) {
      this.loadingCancel = true;

      var response = await this.orderApi.cancelOrder({
        id: this.order.id,
        cancelSince: dateSince,
      });

      this.loadingCancel = false;
      this.isCancelDialogOpen = false;

      this.$sideAlert(
        `Objednávka byla ${response.data.deleted ? "odstraněna" : "zrušena"}.`,
        "accent darken-1"
      );

      if (response.data.deleted) {
        this.$router.push({ name: "orders" });
      }

      this.$emit("cancelled");

      await this.loadOrder();
    }
  }

  async loadSlotInstances(isReturn: boolean) {
    this.loadingSlots = true;

    if (this.order.state == OrderState.New || this.order.id == 0) {
      if (isReturn) {
        this.order.slotInstanceReturnId = undefined;
      } else {
        this.order.slotInstanceId = undefined;
      }
    }

    if (isReturn && this.returnTime.pickup && this.returnTime.dropoff) {
      let pickupTime = new Date();
      let dropoffTime = new Date();

      if (this.returnTime.primaryTime == TimeType.Pickup) {
        pickupTime = new Date(`${this.order.date} ${this.returnTime.pickup}`);
        dropoffTime = new Date(
          pickupTime.getTime() + this.order.duration * 1000
        );
      } else if (this.returnTime.primaryTime == TimeType.Dropoff) {
        dropoffTime = new Date(`${this.order.date} ${this.returnTime.dropoff}`);
        pickupTime = new Date(
          dropoffTime.getTime() - this.order.duration * 1000
        );
      }

      var resultReturn = await this.slotInstanceApi.getSlotInstancesPlanning(
        pickupTime.toISOString(),
        dropoffTime.toISOString(),
        1,
        -1,
        false
      );

      if (resultReturn.data.data) {
        this.returnSlotInstances = resultReturn.data.data;
      }

      this.loadingSlots = false;
      return;
    } else if (!isReturn && this.toTime.pickup && this.toTime.dropoff) {
      let pickupTime = new Date();
      let dropoffTime = new Date();

      if (this.toTime.primaryTime == TimeType.Pickup) {
        pickupTime = new Date(`${this.order.date} ${this.toTime.pickup}`);
        dropoffTime = new Date(
          pickupTime.getTime() + this.order.duration * 1000
        );
      } else if (this.toTime.primaryTime == TimeType.Dropoff) {
        dropoffTime = new Date(`${this.order.date} ${this.toTime.dropoff}`);
        pickupTime = new Date(
          dropoffTime.getTime() - this.order.duration * 1000
        );
      }

      var resultTo = await this.slotInstanceApi.getSlotInstancesPlanning(
        pickupTime.toISOString(),
        dropoffTime.toISOString(),
        1,
        -1,
        false
      );

      if (resultTo.data.data) {
        this.toSlotInstances = resultTo.data.data;
      }
    }

    this.loadingSlots = false;
  }

  async loadCustomer(id: number) {
    this.loadingCustomers = true;

    var result = await this.customerApi.getCustomer(id);

    if (result.data) {
      const customer: GetCustomersModel = {
        id: result.data.id,
        fullName: `${result.data.lastName} ${result.data.firstName}`,
        handicapEquipmentAbbreviation: result.data.handicapEquipmentAbbr,
      };

      this.customers.push(customer);
    }

    this.loadingCustomers = false;
  }

  async loadCustomers(search: string | null = "") {
    if (search == null) {
      search = "";
    }

    this.loadingCustomers = true;

    var result = await this.customerApi.getCustomers(
      true,
      1,
      20,
      false,
      search,
      undefined,
      undefined,
      undefined,
      "fullName"
    );

    if (result.data.data) {
      this.customers = result.data.data;
    }

    this.loadingCustomers = false;
  }

  async loadHandicapEquipment() {
    var result = await this.enumsApi.getHandicapEquipment();

    if (result.data) {
      this.handicapEquipment = result.data.equipments || [];
    }
  }

  async cloneOrder() {
    if (!this.order.id) {
      return;
    }

    var result = await this.orderApi.cloneOrder(this.order.id);

    if (result.data.id) {
      this.$sideAlert(
        "Objednávka zduplikována. Přesměováno na novou objednávku",
        "accent darken-1",
        6000
      );

      this.$emit("saved", result.data.id);
    }
  }

  get showCreateOneTimeButton(): boolean {
    return (
      !!this.order &&
      this.order.orderType === this.orderTypes.Repeated &&
      this.id > 0
    );
  }

  /**
   * Vytvoří lokální (klon) jednorázové objednávky z opakované,
   * přepne orderType na OneTime a otevře formulář nové objednávky pro úpravy.
   */
  async createOneTimeFromRepeated() {
    if (
      !this.order ||
      !this.order.id ||
      this.order.orderType !== OrderType.Repeated
    ) {
      return;
    }

    // klon + přemapování na OneTime
    const newOrder: any = JSON.parse(JSON.stringify(this.order));

    // nové ID
    newOrder.id = 0;
    // dnešní datum ve formátu YYYY-MM-DD
    const today = this.getTodayLocalIsoDate();

    newOrder.date = today;
    // typ + validace
    newOrder.orderType = OrderType.OneTime;
    newOrder.dateTo = newOrder.date;

    // u nové objednávky nedává smysl updateSince z opakované
    newOrder.updateSince = undefined;

    // pokud jsou adresy s id, vynuluj (ať se to nechová jako update existujících address recordů v orderu)
    this.resetClonedAddressId(newOrder.addressFrom);
    this.resetClonedAddressId(newOrder.addressTo);

    // TIMES: vybrat 1 weekday s vyplněnými časy, ale uložit jen 2 záznamy s weekday=0
    const times: any[] = Array.isArray(newOrder.times) ? newOrder.times : [];

    const hasAnyTime = (t: any) => !!(t?.pickup || t?.dropoff);
    const hasBothTimes = (t: any) => !!(t?.pickup && t?.dropoff);

    const weekdays = [
      ...new Set(
        times
          .map((t) => t?.weekday)
          .filter((w: any) => w !== undefined && w !== null)
      ),
    ].sort((a: number, b: number) => a - b);

    const preferredWeekday = this.toMondayBasedWeekday(today);
    const pickWeekday = (matcher: (group: any[]) => boolean) =>
      weekdays.find((w) => matcher(times.filter((t) => t?.weekday === w))) ??
      null;
    const preferredTimes = times.filter((t) => t?.weekday === preferredWeekday);

    let chosenWeekday =
      weekdays.includes(preferredWeekday) && preferredTimes.some(hasBothTimes)
        ? preferredWeekday
        : null;

    if (chosenWeekday === null) {
      chosenWeekday = pickWeekday((group) => group.some(hasBothTimes));
    }

    if (
      chosenWeekday === null &&
      weekdays.includes(preferredWeekday) &&
      preferredTimes.some(hasAnyTime)
    ) {
      chosenWeekday = preferredWeekday;
    }

    if (chosenWeekday === null) {
      chosenWeekday = pickWeekday((group) => group.some(hasAnyTime));
    }

    const outbound =
      chosenWeekday !== null
        ? times.find(
            (t) => t?.weekday === chosenWeekday && t?.isReturn === false
          )
        : null;

    const ret =
      chosenWeekday !== null
        ? times.find(
            (t) => t?.weekday === chosenWeekday && t?.isReturn === true
          )
        : null;

    const makeDefaultTime = (isReturn: boolean) => ({
      isReturn,
      weekday: 0,
      pickup: undefined,
      dropoff: undefined,
      primaryTime: TimeType.Pickup,
    });

    const newOutbound = outbound
      ? { ...makeDefaultTime(false), ...outbound, isReturn: false, weekday: 0 }
      : makeDefaultTime(false);

    const newReturn = ret
      ? { ...makeDefaultTime(true), ...ret, isReturn: true, weekday: 0 }
      : makeDefaultTime(true);

    // když neexistuje ani jeden plný záznam, neposílej žádné times
    // (uživatel je doplní v detailu)
    if (!newOrder.times || newOrder.times.length === 0) {
      newOrder.times = [];
    }

    // zahoď případná IDčka na time záznamech, pokud existují
    [newOutbound, newReturn].forEach((t: any) => {
      if ("id" in t) t.id = 0;
      if ("timeId" in t) t.timeId = 0;
    });

    const hasFull = (t: any) => t?.pickup != null && t?.dropoff != null;

    // do save posílej jen plné záznamy
    newOrder.times = [newOutbound, newReturn].filter(hasFull);
    this.loading = true;
    this.errors = [];

    try {
      // nastav interně state na New (ať se to uloží jako draft)
      newOrder.state = OrderState.New;

      const result = await this.orderApi.saveOrder(newOrder);

      if (result.data?.id) {
        this.$sideAlert("Jednorázová jízda vytvořena", "accent darken-1");

        console.log(result);
        // přesměrovat na nový detail (tím se opraví i hlavička v OrderView)
        this.$router.push({
          name: "order",
          params: { id: String(result.data.id) },
        });
      }
    } catch (e) {
      const parsedErrors = parseAxiosError(e as AxiosError).filter(
        (error) => error && error.trim().length > 0
      );
      this.errors =
        parsedErrors.length > 0
          ? parsedErrors
          : ["Jednorázovou jízdu se nepodařilo vytvořit."];
      this.$sideAlert(
        this.errors[0] || "Jednorázovou jízdu se nepodařilo vytvořit.",
        "error"
      );
    } finally {
      this.loading = false;
    }
  }
}
